import CustomModal from "../../../../components/CustomModal";
import LectureViewer from "./LectureViewer";
import QuizViewer from "./QuizViewer";

type ContentType = "lecture" | "quiz";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  type: ContentType | null;
  contentId: number | null;
};

export default function CourseContentModal({
  isOpen,
  onClose,
  type,
  contentId,
}: Props) {
  if (!type || !contentId) return null;

  return (
    <CustomModal
      open={isOpen}
      handleClose={onClose}
      title={type === "lecture" ? "Lecture Details" : "Quiz Details"}
      size={type === "lecture" ? 900 : 700}
      destroyOnClose
    >
      <div className="max-h-[80vh] overflow-y-auto pr-2 custom-scrollbar">
        {type === "lecture" ? (
          <LectureViewer lectureId={contentId} />
        ) : (
          <QuizViewer quizId={contentId} />
        )}
      </div>
    </CustomModal>
  );
}
